<script lang="ts">
    interface Props {
        height?: string;
        width?: string;
        fillColor?: string;
        strokeColor?: string;
        hover?: string;
        classList?: string;
    }

    let {
        height = "h-6",
        width = "w-6",
        fillColor = "fill-white",
        strokeColor = "stroke-white",
        hover = "group-hover/btn-emoji:fill-white",
        classList = "aspect-ratio transition-all",
    }: Props = $props();
</script>

<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="{height} {width} {strokeColor} {fillColor} {classList} {hover} icon icon-tabler icons-tabler-filled icon-tabler-hat"
>
    <path
        d="M19.2041 13.7652C21.2329 14.1901 22.4997 14.7908 22.5 15.4595C22.4992 16.748 17.7985 17.7935 12 17.7935C6.20153 17.7935 1.50084 16.748 1.5 15.4595C1.50031 14.7911 2.76584 14.1902 4.79297 13.7652C9.54167 14.7928 14.4553 14.7924 19.2041 13.7652ZM13.7324 7.16067C15.0991 6.13605 17.0672 6.87916 17.416 8.5513L18.1738 12.1909C14.0962 12.9842 9.90377 12.9842 5.82617 12.1909L6.58594 8.55227C6.93451 6.87967 8.9027 6.13653 10.2695 7.16165L10.6006 7.4097C11.43 8.03168 12.5709 8.03152 13.4004 7.4097L13.7324 7.16067Z"
    />
</svg>
